import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.isAscs = 'ASC'
      this.orderByColumns = ''
      this.ticketInfo = ''
      // this.deadline = ''
      this.qty = 1
      this.customerPhone = ''
    }
  }
}
export default searchFrom
